<template>
  <div class="person-record-cla">
    <zkThreeRow>
      <div slot="search">
        <el-form
          :model="personForm"
          ref="ruleForm"
          class="demo-ruleForm"
          :inline="true"
        >
          <el-form-item :label="$t('witnessRecord.checkTime')" prop="time">
            <el-date-picker
              class="pickData_cla"
              v-model="value2"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="-"
              :start-placeholder="$t('common.startTime')"
              :end-placeholder="$t('common.endTime')"
              :picker-options="pickerOptions"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('witnessRecord.checkResult')" prop="status">
            <el-select
              v-model="personForm.status"
              :placeholder="$t('common.chooseOptions')"
              clearable
            >
              <el-option
                v-for="item in statusList"
                :key="item.key"
                :label="item.label"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Sn" prop="sn">
            <el-input v-model="personForm.sn"></el-input>
          </el-form-item>
          <el-form-item :label="$t('witnessRecord.name')" prop="name">
            <el-input v-model="personForm.name"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="seatchPersonRecord">{{
              $t('operation.search')
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div slot="table">
        <zk-table
          :data="personTable"
          :columns="personColumn"
          :showTableMenu="true"
        >
          <span slot="tableTip">
            <span class="normal-cla"
              ><span class="base-circle"></span>
              {{ $t('witnessRecord.normalTemperature') }}</span
            >
            <span class="error-cla"
              ><span class="base-circle"></span>
              {{ $t('witnessRecord.abnormalTemperature') }}</span
            >
          </span>
        </zk-table>
        <div class="pagination-margin-top">
          <el-pagination
            background
            @size-change="pageSizeChange(arguments[0], getPersonRecordList)"
            @current-change="curPageChange(arguments[0], getPersonRecordList)"
            :current-page="pager.curPage"
            :page-size="pager.pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="pager.total"
          ></el-pagination>
        </div>
        <verify-photo ref="verifyPhoto"></verify-photo>
      </div>
    </zkThreeRow>
  </div>
</template>

<script>
import { getStartTime, getEndTime } from '@/utils/utils.js'
import { getPersonRecordList } from '@/services/attendanceApi'
import pickerOptions from '@/utils/pickerOptions.js'
export default {
  inject: [
    'statusList',
    'hasStatus',
    'hasTemperature',
    'hasMask',
    'hasVerifyMode'
  ],
  data() {
    let _self = this
    return {
      pickerOptions: pickerOptions(this),
      value2: [],
      personForm: {
        time: '',
        status: '',
        sn: '',
        name: '',
        startTime: '',
        endTime: '',
        appId: ''
      },
      personTable: [],
      personColumn: [
        {
          label: 'Sn',
          prop: 'sn'
        },
        {
          label: this.$t('witnessRecord.name'),
          prop: 'firstName'
        },
        {
          label: this.$t('witnessRecord.checkTime'),
          prop: 'time'
        },
        {
          label: this.$t('witnessRecord.checkResult'),
          prop: 'status',
          render: (h, params) => {
            return h(..._self.hasStatus(params.row.status))
          }
        },
        {
          label: this.$t('witnessRecord.temperature'),
          prop: 'temperature',
          visiable: true,
          render: (h, params) => {
            return h(..._self.hasTemperature(params.row.temperature))
          }
        },
        {
          label: this.$t('witnessRecord.hasMask'),
          prop: 'maskStatus',
          visiable: true,
          render: (h, params) => {
            return h(..._self.hasMask(params.row.maskStatus))
          }
        },
        {
          label: this.$t('witnessRecord.checkMode'),
          prop: 'verifyMode',
          visiable: true,
          render: (h, params) => {
            return h(..._self.hasVerifyMode(params.row.verifyMode))
          }
        },
        {
          label: this.$t('attendanceRecord.verifyPhoto'),
          prop: 'verifyPhoto',
          render: (h, params) => {
            if (params.row.verifyPhoto === undefined || params.row.verifyPhoto === '') {
              return h('span')
            } else {
              return h(
                'span',
                {
                  style: {
                    color: '#4db22f',
                    cursor: 'pointer'
                  },
                  on: {
                    click: () => {
                      this.$refs.verifyPhoto.showPhotoDia(params.row.verifyPhoto)
                    }
                  }
                },
                this.$t('attendanceRecord.view')
              )
            }
          }
        }
      ]
    }
  },
  methods: {
    seatchPersonRecord() {
      this.pager.curPage = 1
      this.getPersonRecordList()
    },
    getPersonRecordList() {
      let valueLength = this.value2 && this.value2.length === 2
      this.personForm.startTime = valueLength
        ? getStartTime(this.value2[0]) / 1000
        : ''
      this.personForm.endTime = valueLength
        ? parseInt(getEndTime(this.value2[1]) / 1000)
        : ''
      if (sessionStorage.getItem('role') === '"developer"') {
        this.personForm.appId = this.$root.appKey
      }
      let params = {
        params: this.personForm,
        pager: this.pager
      }
      getPersonRecordList(params)
        .then(data => {
          if (data.code === '00000000') {
            this.personTable = data.payload.results
            this.pager.total = data.payload.totalRecords
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => this.errorMessage())
    }
  },
  mounted() {
    this.showLoad()
    this.$nextTick(() => {
      let _self = this
      let t = setTimeout(() => {
        _self.getPersonRecordList()
        _self.closeLoad()
        clearTimeout(t)
      }, 500)
    })
    this.value2 = []
    let firstDate = new Date()
    firstDate.setDate(1)
    let currentData = new Date()
    this.value2.push(firstDate)
    this.value2.push(currentData)
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.person-record-cla {
  margin-top: 15px;
  .base-circle {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin: 0 10px;
  }
  .error__color {
    color: @ststusFailed;
  }
  .normal__color {
    color: @statusSuccess;
  }
  .normal-cla {
    .normal__color;
    span {
      background: @statusSuccess;
    }
  }
  .error-cla {
    .error__color;
    span {
      background: @ststusFailed;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/witness/personRecord.vue